export default __webpack_public_path__ + "static/media/close.5ed96ee2.svg";